import React from 'react';
import { Flex, Text } from '@tapresearch/ui/components';

export const BreadcrumbText = ({
  active = false,
  rightElement,
  children,
  ...rest
}) => (
  <Flex position="relative" h="100%" align="center">
    <Text
      {...{
        transitionProperty: 'common',
        transitionDuration: 'normal',
        fontSize: { base: 'md', md: 'lg' },
        fontWeight: 'medium',
        position: 'relative',
        maxW: { base: '190px', md: '340px' },
        color: active ? 'gray.800' : 'gray.500',
        py: 1,
        px: 1,
        _hover: {
          color: active ? 'gray.800' : 'blue.800',
        },
      }}
      {...rest}
    >
      {children}
    </Text>
    {rightElement}
  </Flex>
);
